import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type Task = components['schemas']['Task'];
export type TasksIndex = components['schemas']['TasksIndex'];

export type FetchTasksQuery = NonNullable<paths['/executor_web/tasks']['get']['parameters']['query']>;

/** GET `/api/executor_web/v1/executor_web/tasks` — см. `paths['/executor_web/tasks']` в openapi */
export function fetchTasks(query?: FetchTasksQuery, signal?: AbortSignal) {
	return axiosInstance.get<TasksIndex>('tasks', {params: query, signal});
}
